exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ModulesList__container{font:var(--main-font)}", ""]);

// Exports
exports.locals = {
	"container": "ModulesList__container"
};